module.exports = __webpack_public_path__ + "static/media/cafeteria.49c3ada2.jpg";